import React, { useEffect, useState } from "react";
import { Route, Routes, Navigate, useLocation } from "react-router-dom";
import routes from "routes.js";
import UserNavbar from "components/Navbars/UserNavbar";
import UserFooter from "components/Footers/UserFooter";
import { ToastContainer } from "react-toastify";
import SurveyIframe from "views/users/Survey-Iframe";
import "../css/style.css";
import "../css/variable.css";
import IframeTester from "views/users/iframeTester";

const User = (props) => {
  const [scriptLoaded, setScriptLoaded] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const script = document.createElement("script");
    script.type = "text/javascript";
    script.async = true;
    script.src = "/tailwind-cdn.js";

    script.onload = () => {
      setScriptLoaded(true);
    };

    document.head.appendChild(script);

    return () => {
      document.head.removeChild(script);
    };
  }, []);

  const mainContent = React.useRef(null);

  const getRoutes = (routes) => {
    return routes.flatMap((prop, key) => {
      if (prop.layout === "/user") {
        const routePath = prop.path.replace(/^\//, "");

        // collect normal route
        const mainRoute = (
          <Route path={routePath} element={prop.component} key={key} />
        );

        // collect subRoutes as siblings (NOT nested)
        const children =
          prop.subRoutes?.map((sub, subKey) => (
            <Route
              path={`${routePath}/${sub.path.replace(/^\//, "")}`}
              element={sub.component}
              key={`${key}-${subKey}`}
            />
          )) || [];

        return [mainRoute, ...children];
      }
      return [];
    });
  };

  if (!scriptLoaded) {
    return (
      <div className="w-[100vw] main_loader h-[100vh] flex justify-center  items-center ">
        <span class="loader"></span>
      </div>
    );
  }

  const hideNavFooter =
    location.pathname === "/survey-iframe" ||
    location.pathname === "/survey-iframe-tester";

  return (
    <>
      <div className="main-content" ref={mainContent}>
        <ToastContainer />
        {!hideNavFooter && <UserNavbar />}
        <Routes>
          <Route path="/survey-iframe" element={<SurveyIframe />} />
          <Route path="/survey-iframe-tester" element={<IframeTester />} />
          {getRoutes(routes)}
          <Route path="*" element={<Navigate to="/home" replace />} />
        </Routes>
        {!hideNavFooter && <UserFooter />}
      </div>
    </>
  );
};

export default User;
